export default __webpack_public_path__ + "static/media/spark_64.386d2296.png";